import AXIOS from "./axios";

export class CreditCard {
  static async create(credit_card) {
    return AXIOS.post("/gateway_payments/credit_cards", { credit_card });
  }

  static fetch() {
    return AXIOS.get("/gateway_payments/credit_cards");
  }

  static delete(id) {
    return AXIOS.delete(`/gateway_payments/credit_cards/${id}`);
  }

  static update({ id, nickname }) {
    return AXIOS.put(`/gateway_payments/credit_cards/${id}`, {
      credit_card: { nickname }
    });
  }
}
